import { FunctionComponent } from 'react';
import { VGDisclaimerFooter } from '../../../components/VGDisclaimerFooter/VGDisclaimerFooter';
import { usePropertyPageModalContext } from '../../contexts/PropertyPageModalContext/PropertyPageModalContext';
import { trackDisclaimerModalOpen } from '../../../analytics/event-tracking/trackDisclaimerModalOpen';
import { styled } from 'styled-components';
import { mediaHelper, spacingHelper } from '@property.com.au/ui-kit';

const Wrapper = styled.div`
  padding-bottom: ${spacingHelper('large')};

  ${mediaHelper('tabletMax')} {
    padding-left: ${spacingHelper('large')};
    padding-right: ${spacingHelper('large')};
  }

  > div {
    margin: 0 auto;
    max-width: 850px;
    width: 100%;
  }
`;

export const PropertyPageVGDisclaimerFooter: FunctionComponent = () => {
  const { displayModal } = usePropertyPageModalContext();

  return (
    <Wrapper>
      <VGDisclaimerFooter
        onDisclaimerLinkClick={() => {
          displayModal({ name: 'propertyPageDataDisclaimer' });
          trackDisclaimerModalOpen({
            inPageSource: ['property_page', 'footer_disclaimer', 'button'].join('__'),
          });
        }}
      />
    </Wrapper>
  );
};
